import type { LucideIcon } from 'lucide-react';
import type { ReactNode } from 'react';

export type AppShellRailActionItem = {
  icon: LucideIcon;
  label: string;
  onClick: () => void;
  isActive?: boolean;
  /** Visual-only disabled state; item remains clickable (e.g. upsell redirect). */
  isDisabled?: boolean;
  /** Show selected styling while `isDisabled` (beta upsell on the route subproduct). */
  allowActiveWhenDisabled?: boolean;
  renderTooltip?: () => ReactNode;
  /** Passed to the rail button element, e.g. for product tours. */
  dataTour?: string;
};

export type AppShellRailRenderItem = {
  render: () => ReactNode;
};

export type AppShellRailItem = AppShellRailActionItem | AppShellRailRenderItem;

export type AppShellLeftRailConfig = {
  top: AppShellRailItem[];
  centerTop: AppShellRailItem[];
  centerBottom: AppShellRailItem[];
  bottom: AppShellRailItem[];
};

export function isAppShellRailRenderItem(item: AppShellRailItem): item is AppShellRailRenderItem {
  return 'render' in item;
}
